import { Link, useLocation } from "react-router";
import { KeyIcon, LayersIcon, ScrollIcon, SparklesIcon, TagIcon } from "./Icon";
import styles from "./Sidebar.module.css";

const entries = [
  { href: "/skills", label: "Skills", Icon: SparklesIcon },
  { href: "/traits", label: "Traits", Icon: KeyIcon },
  { href: "/topics", label: "Topics", Icon: LayersIcon },
  { href: "/tags", label: "Tags", Icon: TagIcon },
  { href: "/quests", label: "Quests", Icon: ScrollIcon },
];

export const Sidebar = () => {
  const { pathname } = useLocation();

  return (
    <nav className={styles.sidebar} aria-label="Sections">
      <span className={styles.brand}>QUEST EDITOR</span>
      <ul className={styles.list}>
        {entries.map(({ href, label, Icon }) => {
          // Segment-boundary match, so /tags does not also light up for a
          // future sibling route like /tags-archive.
          const isActive = pathname === href || pathname.startsWith(`${href}/`);

          return (
            <li key={href}>
              <Link
                to={href}
                className={styles.entry}
                data-active={isActive || undefined}
                aria-current={isActive ? "page" : undefined}
              >
                <Icon />
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
      <span className={styles.workspace}>Workspace — Content</span>
    </nav>
  );
};
